<template>
  <div id="couponCodes">
    <v-container>
      <v-row>
        <v-col>
          <app-spinner v-if="loading" />
          <h2 v-if="codeLists.length === 0" class="text-center font-weight-light">No Codes</h2>
          <v-expansion-panels v-else inset focusable>
            <v-expansion-panel v-for="(codeList, index) in codeLists" :key="index">
              <v-expansion-panel-header>
                <span>{{ codeList.list_name }}</span>
                <span class="text-right mr-2"> {{ codeList.used_codes }} / {{ codeList.total_codes }} ({{ codeList.used_percentage }}%) </span>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row v-if="codeList.offer" class="mt-0">
                  <v-col class="body-2"> Applied to: {{ codeList.offer.summary }} </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-simple-table>
                      <template #default>
                        <thead>
                          <tr>
                            <th class="text-left">Code</th>
                            <th class="text-left">Used At</th>
                            <th class="text-left">Used By</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="code in codeList.codes" :key="code.id">
                            <td>{{ code.value }}</td>
                            <td v-if="code.used_at">{{ code.used_at | monthDayYearDate }}</td>
                            <td v-else></td>
                            <td>{{ code.used_by }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Vue from 'vue'

import { mapGetters } from 'vuex'

export default Vue.extend({
  name: 'CouponCodes',

  metaInfo: {
    title: 'Coupon Codes',
  },

  computed: {
    ...mapGetters('couponCodes', ['loading', 'codeLists']),
  },

  mounted() {
    this.$store.dispatch('couponCodes/refresh')
  },
})
</script>

<style lang="scss" scoped>
#couponCodes {
  width: 100%;
}
</style>
